import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardsService {

  _baseURL: string = environment.baseURL;
  _layout: string = environment.layout;
  _content: string = environment.content;
  _site: string = environment.site
  _page: string = "monitoring_usage";
  

  constructor(private _http: HttpClient) { }

  monitoringData() {
    
    // some of this parameters could go into the interceptor
    let params = new HttpParams();
        params = params.append("site", this._site);
        params = params.append("layout", this._layout);
        params = params.append("page", this._page);
        params = params.append("action", "getMonitoringData");
        params = params.append("content", "json");

    return this._http.get(`${this._baseURL}monitoring_usage_dashboard.p`, {params: params, responseType: 'text'} ).pipe( map( response => { 
        return JSON.parse(response);
    }));

  }

 
}
